// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__22BF7","right":"Footer_right__2FQ_k","buttons":"Footer_buttons__wU7-c"};